module.exports = __webpack_public_path__ + "img/left_question.530099cb.png";